import { EffectsCommandMap } from 'dva';
import { ConnectState } from '@/models/connect';
import { FServiceAPI, FUtil } from '@freelog/tools-lib';
import fMessage from '@/components/fMessage';
import { history } from '@@/core/history';
import type {
  ChangeAction,
  OnChange_step4_resourceCover_Action,
  OnChange_step4_resourceLabels_Action,
  OnClick_step4_preBtn_Action,
  OnClick_step4_submitBtn_Action,
} from './types';

export const step4Effects = {
  *onChange_step4_resourceCover(
    { payload }: OnChange_step4_resourceCover_Action,
    { select, put }: EffectsCommandMap,
  ) {
    const { resourceCreatorPage }: ConnectState = yield select(
      ({ resourceCreatorPage }: ConnectState) => ({
        resourceCreatorPage,
      }),
    );

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        step4_resourceCover: payload.value,
        step4_dataIsDirty_count: resourceCreatorPage.step4_dataIsDirty_count + 1,
      },
    });
  },
  *onChange_step4_resourceLabels(
    { payload }: OnChange_step4_resourceLabels_Action,
    { select, put }: EffectsCommandMap,
  ) {
    const { resourceCreatorPage }: ConnectState = yield select(
      ({ resourceCreatorPage }: ConnectState) => ({
        resourceCreatorPage,
      }),
    );
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        step4_resourceLabels: payload.value,
        step4_dataIsDirty_count: resourceCreatorPage.step4_dataIsDirty_count + 1,
      },
    });
  },
  *onClick_step4_preBtn({}: OnClick_step4_preBtn_Action, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        step: 3,
      },
    });
  },
  *onClick_step4_submitBtn(
    {}: OnClick_step4_submitBtn_Action,
    { select, call, put }: EffectsCommandMap,
  ) {
    const { resourceCreatorPage }: ConnectState = yield select(
      ({ resourceCreatorPage }: ConnectState) => ({
        resourceCreatorPage,
      }),
    );

    const params: Parameters<typeof FServiceAPI.Resource.update>[0] = {
      resourceId: resourceCreatorPage.step1_createdResourceInfo?.resourceID || '',
      tags: resourceCreatorPage.step4_resourceLabels,
      coverImages:
        resourceCreatorPage.step4_resourceCover !== ''
          ? [resourceCreatorPage.step4_resourceCover]
          : undefined,
      status: 1,
      intro: resourceCreatorPage.step4_resourceIntroduction,
    };
    const {
      ret,
      errCode,
      msg,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data: any;
    } = yield call(FServiceAPI.Resource.update, params);
    if (ret !== 0 || errCode !== 0) {
      fMessage(msg, 'error');
      return;
    }
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        step4_dataIsDirty_count: 0,
      },
    });
    setTimeout(() => {
      history.push(
        FUtil.LinkTo.resourceCreateSuccess({
          resourceID: resourceCreatorPage.step1_createdResourceInfo?.resourceID || '',
        }),
      );
    }, 100);
  },
};
